import { ChangeEvent, FC, HTMLAttributes, useId } from 'react'

interface Props extends HTMLAttributes<HTMLFieldSetElement> {
  label: string
  name: string
  value: string | number
  onUpdate: (value: string) => void
  options: { label: string; value: string | number }[]
}

const ButtonGroup: FC<Props> = ({
  label,
  name,
  value,
  onUpdate,
  options,
  ...rest
}) => {
  const handleUpdate = (e: ChangeEvent<HTMLInputElement>) => {
    onUpdate(e.currentTarget.value)
  }
  const uniqueId = useId()

  return (
    <fieldset {...rest}>
      <legend className="mb-1">
        <label className="FormLabel">{label}</label>
      </legend>

      <div className="FormButtonGroup FormButtonGroup--small FormButtonGroup--fill">
        {options.map((option, index) => {
          const id = `button-group-${name}-${index}`
          return (
            <span key={option.label} className="FormButtonGroup-button">
              <input
                className="FormButtonGroup-input"
                id={`${id}${uniqueId}`}
                data-testid={id}
                name={name}
                value={option.value}
                onChange={handleUpdate}
                checked={option.value === value}
                type="checkbox"
              />
              <label
                className="FormButtonGroup-label"
                htmlFor={`${id}${uniqueId}`}
              >
                {option.label}
              </label>
            </span>
          )
        })}
      </div>
    </fieldset>
  )
}

export default ButtonGroup
